import config from "config/config";
import LandingEVL from "./landing-evl";
import LandingWLP from "./landing-wlp";

export default function Landing({
  hideCustomChat,
  setHideCustomChat,
  connectingToSF,
  setConnectingToSF,
  openChatWindow,
  setOpenChatWindow,
  bannerMessage,
  bannerTitle,
}) {
  return config.COMPANY_NAME === "everlake" ? (
    <LandingEVL
      portal="customer"
      hideCustomChat={hideCustomChat}
      setHideCustomChat={setHideCustomChat}
      connectingToSF={connectingToSF}
      setConnectingToSF={setConnectingToSF}
      openChatWindow={openChatWindow}
      setOpenChatWindow={setOpenChatWindow}
      bannerMessage={bannerMessage}
      bannerTitle={bannerTitle}
    />
  ) : (
    <LandingWLP
      portal="customer"
      hideCustomChat={hideCustomChat}
      setHideCustomChat={setHideCustomChat}
      connectingToSF={connectingToSF}
      setConnectingToSF={setConnectingToSF}
      openChatWindow={openChatWindow}
      setOpenChatWindow={setOpenChatWindow}
    />
  );
}
